import { createContext } from "react";

export const authContext = createContext({});
